import styled from 'styled-components';
import TextInput from '@nebula/text-input';

export const StyledTextInput = styled(TextInput)`
  background-color: transparent;
  outline: none;
  font-size: 1rem;
`;
